import React from 'react';
import * as S from './ThankyouSucessStyle'
const MobileHeader = props => {
    
    return (
        <S.MobileHeaderContainer>

<div className="headerBox col-md-12 col-sm-12 col-xs-12">
	<div className="hdrLeft">
        
		<a href="/" className="hdrLogo"><img src="//goibibo.ibcdn.com/styleguide/images/goLogo.png"/></a>
		
	</div>
	<div className="hdrRight">
		{/* <div className="width100 fl txtRight padB5 padR5">
		  
			<a href="/support/" className="hdrCusSupport padR15 vMid">
				<small className="fl ico13 lh1-2">24x7 goCare Support</small>
			</a>
		  
          <span className="dib txtRight hdrUserName vMid" id="hdr_user_signin">
			<span className="ico13 blue db">
				<span onClick={()=>{}}>Sign In</span> /
				<span onClick={()=>{}}>Sign up</span>
			</span>
		  </span>
        </div> */}

		
		{/* <a href="/gocash/view/" className="dib vMid mobdn marginT2 hdrgoCash padR10" id="gocashDiv">
		 	<span className="db">
				<span className="availGocash">
		  			<img src="https://goibibo.ibcdn.com/styleguide/images/goCash-header.png" width="23px" height="23px" className="fl"/>
		  				<span className="fl">
		  					<span className="fl padB4 blue fmed textOverflow padL5 padT3">
							<span className="icon-rupee ico12 fl padT3"></span>
							<span className="fl ico16" id="gocashTotal">0</span>
						</span>
		  			</span>
		  		</span>
		  	</span>
			<span className="fl ico13 lh1-2 padL5 posRel width100 txtCenter padT2" id="gocashView">Earn gocash</span>
		</a> */}
        
	        <div className="fmtTooltip hdrUser vMid" id="hd_user_widdget">
				<div className="userPhoto">
					<i className="fl icon-user blue ico30 padT5 padLR5"></i>
					<span className="goBizLogoHdr"></span>
				</div>
				<div className="tip tip_top right white moreSubLinks">
					
					<ul>
						{/* <li>
							<div className="dn ipaddb mobdb">
								<span className="fl" onClick={()=>{}}>Sign In</span> <span className="fl padT10 ico14">/</span>
								<span className="fl" onClick={()=>{}}>Sign up</span>
							</div>
						</li> */}
						
							<li><a href="/support/">My Trips</a></li>
							<li><a href="/support/">View Ticket</a></li>
							<li><a href="/support/">Cancel Ticket</a></li>
							<li><a href="/support/">Make Payment</a></li>
							<li><a href="/support/">Check Refund Status</a></li>
							<li><a href="/contactus/">Write to us</a></li>
						
					</ul>
				</div>
			</div>
        
		<div className="hdrMobMoreLinks">
			
			<a href="javascript:void(0);" className="fl ico24 blue"><i className="mobMenu fl icon-menu1 blue ico20"></i></a>
			
			<ul className="mobMoreMenu">
            <li><a href="/flights/">Flights</a></li>
            <li><a href="/hotels/">Hotels</a></li>
            <li><a href="/trains/">Trains</a></li>
            <li><a href="/cars/">Cabs</a></li>
            <li><a href="/bus/">Bus</a></li>
            <li><a href="/support/">Contact Us</a></li>
          																						
				
 				 
			</ul>
		</div>
	</div>

	
</div>
        </S.MobileHeaderContainer>
    )
}
export default MobileHeader;